// const storagePolicyFormat = [
//     {
//         code: 'NECESSARY',
//         enabled: false
//     }
// ]

// const itemKeyWithVariables = 'item_key_{{id}}'

// const storageManagerPutParams = {
//     key: item_key_{{id}},
//     value: any,
//     storageLevel: StorageLevelMap = LOCAL_STORAGE,
//     expiryDays: number = 1,
//     codec: boolean = true,
//     variables: {id: 123}
// }


const storageKeyPrefix = 'h_';
const storagePolicyExpiryDays = 30;
const storagePolicyKey = `${storageKeyPrefix}storage-policy`;
const notSupportedMsg = 'is not supported storage key';

const StorageItemsCategoriesCodesMap = {
    NECESSARY: 'NECESSARY',
    PREFERENCES: 'PREFERENCES',
    ANALYTICS: 'ANALYTICS'
};
const StorageItemsSourcesCodesMap = {
    HARRI: 'HARRI'
};
const StorageLevelMap = {
    COOKIES: 'COOKIES',
    LOCAL_STORAGE: 'LOCAL_STORAGE',
    SESSION: 'SESSION',
};

const HStorageItems = [
    {
        code: StorageItemsCategoriesCodesMap.NECESSARY,
        alwaysEnabled: true,
        label: 'Necessary',
        sources: [
            {
                code: StorageItemsSourcesCodesMap.HARRI,
                label: 'Harri',
                items: [
                    {
                        key: 'storage-policy',
                    },
                    {
                        key: 'csrftoken',
                    },
                    {
                        key: 'hmap_active_ui_view',
                    },
                    {
                        key: 'hmap_active_view',
                    },
                    {
                        key: 'hmap_active_sorting',
                    },
                    {
                        key: 'user',
                    },
                    {
                        key: 'lang',
                    },
                    {
                        key: 'userContext',
                    },
                    {
                        key: 'send_on_enter',
                    },
                    {
                        key: 'InteractBrandsCookie',
                    },
                    {
                        key: 'selectedJobFilterDashboard',
                    },
                    {
                        key: 'mainFocusInput',
                    },
                    {
                        key: 'brand_slug',
                    },
                    {
                        key: 'brand_id',
                    },
                    {
                        key: 'brand_name',
                    },
                    {
                        key: 'tts_li_utms',
                    },
                    {
                        key: 'previous_search',
                    },
                    {
                        key: 'modalFirstJPLP',
                    },
                    {
                        key: 'ONBOARDING_VIEW',
                    },
                    {
                        key: '_hec',
                    },
                    {
                        key: 'mobile-banner-closed',
                    },
                    {
                        key: 'candidateAppMobileWelcome',
                    },
                    {
                        key: 'nopromo',
                    },
                    {
                        key: 'hUserLocation',
                    },
                    {
                        key: 'enterprise_id',
                    },
                    {
                        key: 'enterprise_slug',
                    },
                    {
                        key: 'userRegistrationActiveForm',
                    },
                    {
                        key: 'new_user_user_candidate',
                    },
                    {
                        key: 'new_user_user_employer',
                    },
                    {
                        key: 'toggledBrandsCookie',
                    },
                    {
                        key: 'username_referral',
                    },
                    {
                        key: 'onboarding_attachment_code_lookups',
                    },
                    {
                        key: 'secondAuthToken',
                    },
                    {
                        key: 'abs-productivity-hours',
                    },
                    {
                        key: 'carriStepByStepHideen',
                    },
                    {
                        key: 'brand_selector_list_type_{{id}}',
                    },
                    {
                        key: 'dash_filters_{{id}}',
                    },
                    {
                        key: 'side_bar_state_{{id}}',
                    },
                    {
                        key: 'brand_theme',
                    },
                    {
                        key: 'csp_theme',
                    },
                    {
                        key: 'apply_modal_theme',
                    },
                    {
                        key: 'career_portal_theme',
                    },
                    {
                        key: 'job_page_theme',
                    },
                    {
                        key: 'preview_job_page_theme',
                    },
                    {
                        key: 'brand_profile_theme',
                    },
                    {
                        key: 'healch-check-print-options',
                    },
                    {
                        key: 'qsr_api_key',
                    },
                    {
                        key: 'FlashDashCustomization',
                    },
                    {
                        key: 'review_docs_prev_state',
                    },
                    {
                        key: 'docs_search_{{key}}',
                    },
                    {
                        key: 'job_distance_{{id}}',
                    },
                    {
                        key: 'is_user',
                    },
                    {
                        key: 'employer_sign_document_controller_data',
                    },
                    {
                        key: 'search_filters_1',
                    },
                    {
                        key: 'hide_tl_requests_modal',
                    },
                    {
                        key: 'punch_show_breaks',
                    },
                    {
                        key: 'full_burden_apply_bonus_{{brandId}}_{{date}}',
                    },
                    {
                        key: 'tl_schedule_preset',
                    },
                    {
                        key: 'tl_schedule_visibility{{id}}',
                    },
                    {
                        key: 'tl_schedule_view',
                    },
                    {
                        key: 'tl_sort_by',
                    },
                    {
                        key: 'tl_schedule_filters{{id}}',
                    },
                    {
                        key: 'employee_sort_type',
                    },
                    {
                        key: 'tl_printing_schedule',
                    },
                    {
                        key: 'tl_time_off_sort_by',
                    },
                    {
                        key: 'e_verify_training_visited_chapters_index',
                    },
                    {
                        key: 'selected_business_id',
                    },
                    {
                        key: 'DASHBOARDS_LOCATIONS_FILTER_DATA',
                    },
                    {
                        key: 'HALO_DASHBOARD_VIEW_TYPE{{userId}}',
                    },
                    {
                        key: 'core_hr_employees_view',
                    },
                    {
                        key: 'touchpoints_layout',
                    },
                    {
                        key: 'shift_trade_sort_by',
                    },
                    {
                        key: 'show_request_matching_skills_only',
                    },
                    {
                        key: 'warnings',
                    },
                    {
                        key: 'pre_maintenance',
                    },
                    {
                        key: 'cookies_allowed',
                    },
                    {
                        key: 'walk-through-dashs',
                    },
                    {
                        key: 'walk-through-tts',
                    },
                    {
                        key: 'walk-through-barri',
                    },
                    {
                        key: 'user_location',
                    },
                    {
                        key: 'Recite.Persist',
                    },
                    {
                        key: 'placeholder_token',
                    },
                    {
                        key: '@GP-REPORTS',
                    },
                    {
                        key: 'dashboards__location_ids',
                    },
                    {
                        key: 'dashboards__categories_positions',
                    },
                    {
                        key: '{{area}}',
                    },
                    {
                        key: 'isQSRLogin',
                    },
                    {
                        key: 'isWarningConfirmed',
                    },
                    {
                        key: 'previewJobPayload',
                    },
                    {
                        key: 'jobsFilters{{userId}}',
                    },
                    {
                        key: 'applicantsFilters{{userId}}',
                    },
                    {
                        key: 'uploadEmployeesFilters{{userId}}',
                    },
                    {
                        key: 'interviewFilters{{userId}}',
                    },
                    {
                        key: 'dontShowRemoveJobWarning',
                    },
                    {
                        key: 'dashboards__previousSelectedFilters__{{userId}}',
                    },
                    {
                        key: 'customWelcomePageShown',
                    },
                    {
                        key: 'shared_state',
                    },
                    {
                        key: 'magicLinkToken',
                    },
                    {
                        key: 'hideIEWarningModal',
                    },
                    {
                        key: 'emailToken',
                    },
                    {
                        key: 'punch-show-breaks-switch-value'
                    },
                    {
                        key: 'career_portal_redirection{{job}}',
                    }
                ]
            }
        ]
    },
    {
        code: StorageItemsCategoriesCodesMap.PREFERENCES,
        label: 'Preferences',
        sources: [
            {
                code: StorageItemsSourcesCodesMap.HARRI,
                label: 'Harri',
                items: [
                ]
            }
        ]
    },
    {
        code: StorageItemsCategoriesCodesMap.ANALYTICS,
        label: 'Analytics',
        sources: []
    }
];

const HStoragePolicyManager = {
    Categories: StorageItemsCategoriesCodesMap,
    allowAll() {
        const categories = [];
        HStorageItems.forEach(cat => {
            categories.push({
                code: cat.code,
                enabled: true
            });
        })
        HCookiesStore.put(storagePolicyKey, categories, storagePolicyExpiryDays, true);
    },
    deny() {
        const categories = [];
        HStorageItems.forEach(cat => {
            categories.push({
                code: cat.code,
                enabled: !!cat.alwaysEnabled
            });
        })
        HCookiesStore.put(storagePolicyKey, categories, storagePolicyExpiryDays, true);
    },
    allowSelection(allowedCategories) {
        const categories = [];
        HStorageItems.forEach(cat => {
            categories.push({
                code: cat.code,
                enabled: cat.alwaysEnabled || allowedCategories.indexOf(cat.code) > -1
            });
        })
        HCookiesStore.put(storagePolicyKey, categories, storagePolicyExpiryDays, true);
    },
    isCategoryEnabled(code) {
        const categories = HCookiesStore.get(storagePolicyKey, true);
        return HStorageItems.find(c => c.code === code)?.alwaysEnabled || categories?.find(cat => cat.code === code)?.enabled;
    },
    isPolicyChecked() {
        const categories = HCookiesStore.get(storagePolicyKey, true);
        return !!categories;
    },
    isItemAllowed(options) {
        return true;
        const categories = HCookiesStore.get(storagePolicyKey, true);
        for (let cat of HStorageItems) {
            for (let src of cat.sources) {
                for (let item of src.items) {
                    if (item.key === options.key) {
                        return cat.alwaysEnabled || categories?.find(c => c.code === cat.code)?.enabled;
                    }
                }
            }
        }
        return false;
    },
    isItemSupported(options) {
        for (let cat of HStorageItems) {
            for (let src of cat.sources) {
                for (let item of src.items) {
                    if (item.key === options.key) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
};

function getStorageKeyForItem(itemName, variables) {
    if (variables) {
        for (let key in variables) {
            itemName = itemName.split(`{{${key}}}`).join(variables[key])
        }
    }
    return storageKeyPrefix + itemName;
}

function getDefaultOptions(key, variables) {
    return {
        codec: true,
        expiryDays: 1,
        storageKey: getStorageKeyForItem(key, variables)
    }
}

function isSessionStorageSupported() {
    try {
        const storage = window?.sessionStorage;
        storage.setItem('test', 'test');
        storage.removeItem('test');
        return true;
    } catch (e) {
        console.warn("Browser doesn't support session storage");
        return false;
    }
}

const HStorageManager = {
    StorageLevels: StorageLevelMap,
    get(_options) {
        const options = {
            ...getDefaultOptions(_options.key, _options.variables),
            ..._options
        };
        if (HStoragePolicyManager.isItemSupported(options)) {
            if (HStoragePolicyManager.isItemAllowed(options)) {
                switch (options.storageLevel) {
                    case StorageLevelMap.COOKIES:
                        return HCookiesStore.get(options.storageKey, options.codec);
                    case StorageLevelMap.SESSION:
                        if (isSessionStorageSupported()) {
                            return HSessionStore.get(options.storageKey);
                        }
                        else {
                            return HMemoryStore.get(options.storageKey);
                        }
                    default:
                        return HLocalStorageStore.get(options.storageKey);
                }
            } else {
                return HMemoryStore.get(options.storageKey);
            }
        } else {
            console.error(`${options.key} ${notSupportedMsg}`);
        }
    },
    put(_options) {
        const options = {
            ...getDefaultOptions(_options.key, _options.variables),
            ..._options
        };
        if (HStoragePolicyManager.isItemSupported(options)) {
            if (HStoragePolicyManager.isItemAllowed(options)) {
                switch (options.storageLevel) {
                    case StorageLevelMap.COOKIES:
                        HCookiesStore.put(options.storageKey, options.value, options.expiryDays, options.codec);
                        break;
                    case StorageLevelMap.SESSION:
                        if (isSessionStorageSupported()) {
                            HSessionStore.put(options.storageKey, options.value);
                        }
                        else {
                            HMemoryStore.put(options.storageKey, options.value);
                        }
                        break;
                    default:
                        HLocalStorageStore.put(options.storageKey, options.value, options.expiryDays);
                }
            } else {
                HMemoryStore.put(options.storageKey, options.value);
            }
        } else {
            console.error(`${options.key} ${notSupportedMsg}`);
        }
    },
    remove(_options) {
        const options = {
            ...getDefaultOptions(_options.key, _options.variables),
            ..._options
        };
        if (HStoragePolicyManager.isItemSupported(options)) {
            if (HStoragePolicyManager.isItemAllowed(options)) {
                switch (options.storageLevel) {
                    case StorageLevelMap.COOKIES:
                        HCookiesStore.remove(options.storageKey);
                        break;
                    case StorageLevelMap.SESSION:
                        if (isSessionStorageSupported()) {
                            HSessionStore.remove(options.storageKey);
                        }
                        else {
                            HMemoryStore.remove(options.storageKey);
                        }
                        break;
                    default:
                        HLocalStorageStore.remove(options.storageKey);
                }
            } else {
                HMemoryStore.remove(options.storageKey);
            }
        } else {
            console.error(`${options.key} ${notSupportedMsg}`);
        }
    }
};

HLocalStorageStore?.cleanExpiredLocalStorageItems(storageKeyPrefix);

if (typeof window !== "undefined") {
    window.HStorageItems = HStorageItems;
    window.HStoragePolicyManager = HStoragePolicyManager;
    window.HStorageManager = HStorageManager;
}